import React from 'react';
import PropTypes from 'prop-types';
import './styles/ClientHome.css';

const propTypes = {
  activateResourceSearch: PropTypes.func.isRequired,
  setView: PropTypes.func.isRequired,
  setSort: PropTypes.func.isRequired,
};

const ClientHome = ({ activateResourceSearch, setView, setSort }) => {
  const clickButton = (searchText) => {
    activateResourceSearch({
      searchText,
    });
    if (searchText === 'housing') {
      setSort('location');
    } else setSort('views');
    setView('resources');
    document.getElementById('search').dispatchEvent(new CustomEvent('activateSearch',
      {
        detail: {
          searchText,
        },
      },
    ));
  };
  return (
    <div id="compass">
      <div className="compass north-west">
        <img src="http://www.bu.edu/globalprograms/files/2018/04/Circle-Top-L.png" alt="Circle-Top-L" />
      </div>
      <div className="compass north tag">
        <img onClick={() => { clickButton('academic ') }} src="http://www.bu.edu/globalprograms/files/2018/04/Academic.png" alt="Academic" />
      </div>
      <div className="compass north-east">
        <img src="http://www.bu.edu/globalprograms/files/2018/04/Circle-Top-R.png" alt="Circle-Top-R" />
      </div>
      <div className="compass west tag">
        <img onClick={() => { clickButton('housing ') }} src="http://www.bu.edu/globalprograms/files/2018/04/Housing.png" alt="Housing" />
      </div>
      <div className="compass center">
        <img src="http://www.bu.edu/globalprograms/files/2018/07/compass-center.png" alt="Compass" />
      </div>
      <div className="compass east tag">
        <img onClick={() => { clickButton('community ') }} src="http://www.bu.edu/globalprograms/files/2018/04/Community.png" alt="Community" />
      </div>
      <div className="compass south-west">
        <img src="http://www.bu.edu/globalprograms/files/2018/04/Circle-Bottom-L.png" alt="Circle-Bottom-L" />
      </div>
      <div className="compass south tag">
        <img onClick={() => { clickButton('employment ') }} src="http://www.bu.edu/globalprograms/files/2018/04/Career-Employment.png" alt="Career_Employment" />
      </div>
      <div className="compass south-east">
        <img src="http://www.bu.edu/globalprograms/files/2018/04/Circle-Bottom-R.png" alt="Circle-Bottom-R" />
      </div>
    </div>
  );
};

ClientHome.propTypes = propTypes;
export default ClientHome;



// WEBPACK FOOTER //
// ./src/components/ClientHome.jsx